import { MutableRefObject } from 'react'

/** Tracks upload promises by key so waitForPendingUploads can await them; superseded uploads (same key) are not removed by older finally handlers. */
export const registerInFlightUpload = (
  pendingUploadsByKey: MutableRefObject<Record<string, Promise<void>>>,
  uploadKey: string,
  uploadPromise: Promise<void>
) => {
  pendingUploadsByKey.current[uploadKey] = uploadPromise
  void uploadPromise.finally(() => {
    if (pendingUploadsByKey.current[uploadKey] === uploadPromise) {
      delete pendingUploadsByKey.current[uploadKey]
    }
  })
}
